import store from '@/store'

// 查询当前页面是否有按钮权限
export function getPermission(path) {
    return store.getters['auth/getCurrentRoute'](path)
}